import React from 'react';
export const formContext = React.createContext<Record<string, any>>({});
